import iconQuickfix from '../img/Logo_QuickFix.svg';
import iconWord from '../img/Logo_Word.svg';
import iconSense from '../img/Logo_Sense.svg';
import iconSlide from '../img/Logo_Slide.svg';
import iconTagger from '../img/Logo_Tagger.svg';
import iconUnknown from '../img/Logo_Unknown.svg';

type ProductInformation = {
    /**
     * Name of the product
     */
    title: string;
    /**
     * URL for the icon
     */
    icon: string;
    /**
     * Module ID
     */
    id: number;
}

const createProducts = (production: boolean): ProductInformation[] => [
    {
        title: 'unknown',
        icon: iconUnknown,
        id: 0,
    },
    {
        title: 'axesWord',
        icon: iconWord,
        id: 100 * (production ? 10 : 1),
    },
    {
        title: 'axesPDF',
        icon: iconQuickfix,
        id: 200 * (production ? 10 : 1),
    },
    {
        title: 'axesTagger',
        icon: iconTagger,
        id: 300 * (production ? 10 : 1),
    },
    {
        title: 'axesSense',
        icon: iconSense,
        id: 400 * (production ? 10 : 1),
    },
    {
        title: 'axesSlide',
        icon: iconSlide,
        id: 500 * (production ? 10 : 1),
    },
];

export const products = [
    ...createProducts(false),
    ...createProducts(true),
];
